import React from "react";
import { ChatContainerWrap } from "./components";
import { useGetAdminChat } from "./hooks";

const ChatInnerPageAdmin = () => (
  <ChatContainerWrap useHook={useGetAdminChat} isAdmin />
);

export default ChatInnerPageAdmin;
